import React from 'react';

import Table from 'components/Table';

const YearSplitter = ({year}) => {
  return (
    <Table.Row className="scheduleRow yearSplitter">
      <Table.Cell className="checkbox" />
      <Table.Cell className="booking" />
      <Table.Cell className="date colab-bold">{year}</Table.Cell>
      <Table.Cell className="dueDate" />
      <Table.Cell className="description" />
      <Table.Cell className="category" />
      <Table.Cell className="status" />
      <Table.Cell className="due" />
    </Table.Row>
  );
};

export default YearSplitter;
